import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/movie";
import { TYPE_LABELS } from "@/types/movie";

export default function MediaCard({ item }: { item: MediaItem }) {
  return (
    <Link to={`/detail/${item.id}`} className="group block">
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border border-background-200 bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 在线观看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-600/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {TYPE_LABELS[item.type]}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-primary-950">
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 flex items-center justify-center bg-primary-950/40 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-primary-950">
            <i className="ri-play-fill text-xl"></i>
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/85 to-transparent p-2 pt-8">
          <p className="truncate text-xs text-background-50/85">
            {item.year} · {item.region}
          </p>
        </div>
      </div>
      <h3
        className="mt-2 truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600"
        title={item.title}
      >
        {item.title}
      </h3>
      <p className="mt-0.5 truncate text-xs text-foreground-600">{item.genres.slice(0, 2).join(" / ")}</p>
    </Link>
  );
}